import React, { useEffect, useRef, useState } from 'react';

//Importacion de librerias
import ReactHowler from 'react-howler';

//Importacion de estilos
import '../../styles/respuesta.css';

//Importacion de imagenes
import muyBien from '../../imgs/otros/Palabra muy bien.png';
import punto from '../../imgs/otros/1punto.png';
import ohNoo from '../../imgs/otros/oh noo.png';
import confetiFondo from '../../imgs/otros/confeti de fondo.png'

//Importacion de sonidos
import respuestaBuena from '../../sounds/correct-6033.mp3';
import respuestaFalsa from '../../sounds/wrong-answer-126515.mp3';



export default function Respuesta(props) {
    // const [ sonidoTipo, setSonidoTipo ] = useState(false);
    const [ activarSonido, setActivarSonido ] = useState(false);
    const { tipoRespuesta } = props;

    // useEffect(() => {
    //     if(tipoRespuesta === true){
    //         setActivarSonido(true);
    //     }else if(tipoRespuesta === false){
    //         setActivarSonido(true);
    //     }
    // }, []);

    const prevTipoRespuestaRef = useRef();

    useEffect(() => {
        // Comparamos el estado anterior con el estado actual
        if (prevTipoRespuestaRef.current !== tipoRespuesta) {
            if (tipoRespuesta === true || tipoRespuesta === false) {
                setActivarSonido(true);

                setTimeout(() => {
                    setActivarSonido(false);
                }, 1000);
            }
        };

        // Actualizamos el ref con el estado actual
        prevTipoRespuestaRef.current = tipoRespuesta;
    }, [tipoRespuesta]);


    //Creamos los componentes en variables para despues traerlos en un condicional que determinara si el usuario respondio bien o mal convertidos en true o false que al final renderizara el componente correspondiente.
    let respuestaTrue = (<div className="respuesta__div--tarjeta-true">
                                <img className='respuesta__img--fondo-confeti' src={confetiFondo} alt={"confeti-fondo.png"}/>
                                <img className='respuesta__img--muy-bien' src={muyBien} alt={"muy-bien.png"}/>
                                <img className='respuesta__img--punto' src={punto} alt={"punto.png"}/>
                        </div>);

    let respuestaFalse = (<div className="respuesta__div--tarjeta-false">
                            <img  className='respuesta__img--oh-no' src={ohNoo} alt={"oh-no.png"}/>
                        </div>
    );


    return (
        <div className="respuesta__div--container">
            <ReactHowler src={tipoRespuesta ? (respuestaBuena):(respuestaFalsa)} playing={activarSonido} />
            {tipoRespuesta ? (respuestaTrue):(respuestaFalse)}
        </div>
    )
};
